<template>
    <div class="row h-100">
        <div
            class="col-5 algolia-listing-product-block__product-pricing-wrapper px-0"
        >
            <div
                class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--sale" v-if="combination.price_from_display" v-text="combination.price_from_display"
            >
            </div>
            <div
                class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--sale" v-else-if="combination.price_from"
            >
                {{ combination.price_from }}
            </div>
        </div>
        <div
            class="col-7 algolia-listing-product-block__product-sale-pricing-wrapper px-0"
        >
            <div
                    class="algolia-listing-product-block__product-sale-price-per-kg"
                    v-text="combination.price_punit_for ? combination.price_punit_for.replace(/[()]/g , '') : combination.price_pkilo_for.replace(/[()]/g , '')"
            >
            </div>
            <div class="algolia-listing-product-block__product-sale-price" itemprop="price">
                {{ combination.price_for_display }}
            </div>
            <div class="algolia-listing-product-block__product-sale-price-subnote">{{ $t('myAccount.discount')}}: {{ combination.price_difference }}</div>
        </div>
      <meta itemprop="availability" href="https://schema.org/InStock" />
    </div>
</template>

<script>
export default {
    name: "PricingReduction",
    props: {
        combination: {
            type: Object,
            required: true
        }
    }
};
</script>
